import React from 'react';
import TimeFromCreation from './TimeFromCreation';
import TaskStatus from './TaskStatus';
import TaskDescription from './TaskDescription';

const Task = ({ comment, commentData, creationTime, id, status, taskType, className }) => {
  return (
    <div data-testid="task" className={className}>
      <div className="group">
        <span className="group__status-field">
          <TaskStatus status={status} id={id} />
        </span>
        <TaskDescription taskType={taskType} comment={comment} commentData={commentData} />
      </div>
      <div className="group">
        <TimeFromCreation time={creationTime} />
      </div>
    </div>
  );
};

export default Task;
